module.exports = __webpack_public_path__ + "img/fichee.1af41163.svg";